<template>
	<sf-data-table
		ref="ClamMstTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="mKObjCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		:customExcel="excelFunc"
		index
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<!--버튼 영역 -->
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/MkObj/store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
/*엑셀다운로드 시작*/
import utils from '@/utils';
import moment from 'moment';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.mkObjList;
		},
		mKObjCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001225'), //클레임 번호
					prop: 'clmNo',
					width: '150px',
					align: 'center',
					highlight: true,
					clickEvent: this.openMkObjNewModal
				},
				{
					label: this.getMessage_('QWCC001566'), //클레임타입
					prop: 'ctypeNm',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002032'), // 변제확정일(클레임확정일)
					prop: 'dcsnDdCl',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000976'), //R/O No
					prop: 'roNo',
					width: '200px',
					align: 'center',
					highlight: true,
					clickEvent: this.openRoApcnPopupModal
				},
				{
					label: this.getMessage_('QWCC001412'), // 이의제기타입
					prop: 'mkobTypeNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001413'), // 이의제기일
					prop: 'aplcDdObj',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000963'), // 처리단계
					prop: 'prcsStepNmObj',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000978'), // 처리결과
					prop: 'prcsRsltNmObj',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001538'), // 제품ID
					prop: 'pmcId',
					width: '170px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'causPartNo',
					width: '150px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'causPartNm',
					width: '240px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001029'), //원인코드
					prop: 'causCd',
					width: '80px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001308'), //원인코드명
					prop: 'causNm',
					width: '200px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001055'), // 현상코드
					prop: 'phmnCd',
					width: '80px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001070'), // 현상코드명
					prop: 'phmnNm',
					width: '250px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001053'), // 사용기간
					prop: 'usePrd',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC000972'), // 주행거리
					prop: 'milg',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001342'), // 협력사명
					prop: 'aplCpnyNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001924'), // 확정협력사 실납품사
					prop: 'aplDlvgNm',
					width: '200px',
					align: 'center'
				},

				// {
				// 	label: this.getMessage_('QWCC002030'), //변제대상금액,
				// 	width: '400px',
				// 	align: 'center',
				// 	children: [
				// 		{
				// 			label: this.getMessage_('QWCC001101'), //자재비
				// 			width: '100px',
				// 			prop: 'mtrlCst',
				// 			headerAlign: 'center',
				// 			align: 'right'
				// 		},
				// 		{
				// 			label: this.getMessage_('QWCC001102'), //'공임비',
				// 			width: '100px',
				// 			prop: 'wags',
				// 			headerAlign: 'center',
				// 			align: 'right'
				// 		},
				// 		{
				// 			label: this.getMessage_('QWCC001103'), //'부대비',
				// 			width: '100px',
				// 			prop: 'incdCst',
				// 			headerAlign: 'center',
				// 			align: 'right'
				// 		},
				// 		{
				// 			label: this.getMessage_('QWCC001104'), //'총금액',
				// 			width: '100px',
				// 			headerAlign: 'center',
				// 			prop: 'totPartCst',
				// 			align: 'right'
				// 		}
				// 	]
				// },
				/*{
					label: this.getMessage_('QWCC002030'), // 변제대상금액
					prop: 'bflRpymAmt2',
					width: '80px',
					headerAlign: 'center',
					align: 'right'
				},
				*/
				{
					label: this.getMessage_('QWCC001168'), // 클레임 분담율 (분담율)
					prop: 'dvswRt',
					width: '80px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001295'), // 클레임 예상변재금액 (변제금액)
					prop: 'rpymAmt',
					width: '80px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001305'), // 클레임 적용분담율 (적용 분담율)
					prop: 'aplDvswRt',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001306'), // 클레임 적용변재금액 (적용 변제금액)
					prop: 'aplRpymAmt',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC002031'), // 완료일(이의처리 완료일)
					prop: 'dcsnDdObj',
					width: '120px',
					headerAlign: 'center',
					align: 'center'
				}
			];
		},
		clamMstExcelCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001225'), //클레임 번호
					prop: 'clmNo',
					width: '150px',
					align: 'center',
					highlight: true,
					clickEvent: this.openMkObjNewModal
				},
				{
					label: this.getMessage_('QWCC001566'), //클레임타입
					prop: 'ctypeNm',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002032'), // 변제 확정일(클레임확정일)
					prop: 'dcsnDdCl',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000976'), //R/O No
					prop: 'roNo',
					width: '200px',
					align: 'center',
					highlight: true,
					clickEvent: this.openRoApcnPopupModal
				},
				{
					label: this.getMessage_('QWCC001412'), // 이의제기타입
					prop: 'mkobTypeNm',
					width: '150px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001413'), // 이의제기일
					prop: 'aplcDdObj',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000963'), // 처리단계
					prop: 'prcsStepNmObj',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000978'), // 처리결과
					prop: 'prcsRsltNmObj',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001538'), // 제품ID
					prop: 'pmcId',
					width: '170px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'causPartNo',
					width: '150px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'causPartNm',
					width: '240px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001029'), //원인코드
					prop: 'causCd',
					width: '80px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001308'), //원인코드명
					prop: 'causNm',
					width: '200px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001055'), // 현상코드
					prop: 'phmnCd',
					width: '80px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001070'), // 현상코드명
					prop: 'phmnNm',
					width: '250px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001053'), // 사용기간
					prop: 'usePrd',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC000972'), // 주행거리
					prop: 'milg',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001342'), // 협력사명
					prop: 'aplCpnyNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001924'), // 확정협력사 실납품사
					prop: 'aplDlvgNm',
					width: '200px',
					align: 'center'
				},
				// {
				// 	label: this.getMessage_('QWCC002030'), //변제대상금액,
				// 	width: '400px',
				// 	align: 'center',
				// 	children: [
				// 		{
				// 			label: this.getMessage_('QWCC001101'), //자재비
				// 			width: '100px',
				// 			prop: 'mtrlCst',
				// 			headerAlign: 'center',
				// 			align: 'right'
				// 		},
				// 		{
				// 			label: this.getMessage_('QWCC001102'), //'공임비',
				// 			width: '100px',
				// 			prop: 'wags',
				// 			headerAlign: 'center',
				// 			align: 'right'
				// 		},
				// 		{
				// 			label: this.getMessage_('QWCC001103'), //'부대비',
				// 			width: '100px',
				// 			prop: 'incdCst',
				// 			headerAlign: 'center',
				// 			align: 'right'
				// 		},
				// 		{
				// 			label: this.getMessage_('QWCC001104'), //'총금액',
				// 			width: '100px',
				// 			headerAlign: 'center',
				// 			prop: 'totPartCst',
				// 			align: 'right'
				// 		}
				// 	]
				// },
				{
					label: this.getMessage_('QWCC001168'), // 클레임 분담율 (분담율)
					prop: 'dvswRt',
					width: '80px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001295'), // 클레임 예상변재금액 (변제금액)
					prop: 'rpymAmt',
					width: '80px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001305'), // 클레임 적용분담율 (적용 분담율)
					prop: 'aplDvswRt',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001306'), // 클레임 적용변재금액 (적용 변제금액)
					prop: 'aplRpymAmt',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC002031'), // 완료일(이의처리 완료일)
					prop: 'dcsnDdObj',
					width: '120px',
					headerAlign: 'center',
					align: 'center'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			/*날짜 포멧변환*/
			let causPartNo;

			/*특수문자가 있는것들은 다음과 같이해줘됨 */
			if (this.searchParams.causPartNo) {
				causPartNo = encodeURIComponent(this.searchParams.causPartNo);
			} else {
				causPartNo = '';
			}

			queryStr = objectToQuerystring({
				dlrCpnyCd: this.searchParams.dlrCpnyCd /*딜러점*/,
				roNo: this.searchParams.roNo /*RO번호*/,
				clmNo: this.searchParams.clmNo /*클래임번호*/,
				causPartNo: causPartNo /*품번*/,
				dlvgNm: this.searchParams.dlvgNm /*실납품사*/,
				ctype: this.searchParams.ctype /*클레임타입*/,
				prcStepGb: this.searchParams.prcStepGb /*처리단계*/,
				prcRsltCd: this.searchParams.prcRsltCd /*처리결과*/,
				startDcsnDd: this.searchParams.startDcsnDd, //변제확정일자from
				endDcsnDd: this.searchParams.endDcsnDd, //변제확정일자to
				startAplcDdObj: this.searchParams.startAplcDdObj, //이의제기일from
				endAplcDdObj: this.searchParams.endAplcDdObj, //이의제기일to
				startDcsnDdObj: this.searchParams.startDcsnDdObj, //이의처리 완료일from
				endDcsnDdObj: this.searchParams.endDcsnDdObj, //이의처리 완료일to
				mkobjCd:this.searchParams.mkobjCd
			});

			//console.log('조회조건>>>>', queryStr);

			//console.log('엑셀컬럼>>>', this.clamMstExcelCols);
			const url = `${BASE_URL}/mqy/qlty/mkObj/v1/excels` + queryStr;

			const params = { url, columns: this.clamMstExcelCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		openMkObjNewModal(row) {
			/*pwa 상세조회*/
			//console.log('값은>>>>', row);

			const selRoNo = convertNvl(row.roNo, '');

			const selClmNo = convertNvl(row.clmNo, '');

			//console.log('selRoNo>>>>>>>', selRoNo);
			//console.log('selClmNo>>>>>>>', selClmNo);

			if (selClmNo != '') {
				const param = {
					title: this.getMessage_('QWCC001775'), //협력사이의제기
					clmNo: row.clmNo
				};
				this.$emit('PopupMkObjectMstNewOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
			}
		},
		openRoApcnPopupModal(row) {
			/*RO신청 버튼 클릭시*/
			//console.log('그리드에서 클레임번호를 클릭했을때>', row);

			const selRoNo = convertNvl(row.roNo, '');

			if (selRoNo != '') {
				const param = {
					title: this.getMessage_('QWCC001769'), //RO상세
					roNo: selRoNo
				};
				this.$emit('PopupRoOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
			}
		},
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		save(saveRows) {
			// console.log('@@@@ saveRows:', saveRows);

			let sendData = {
				status: 1,
				data: saveRows
			};
			/* 나중에 필요할지 몰라서 주석처리함.
			saveRows.forEach(row => {
				let pushSet = {
					varId: row.varId,
					varValue: row.varValue,
					rmk: row.rmk,
					tableState: row.tableState,
					rgtId: '',
					regDt: '',
					chgId: '',
					chgDt: ''
				};
				sendData.data.push(pushSet);
			});
			*/
			//console.log('@@@@ sendData: ', sendData);
			// return

			if (sendData.data != undefined && sendData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.setVariableManagement_(sendData)
					.then(value => {
						if (value.message != undefined && value.message != null) {
							this.$sf_toast({
								type: value.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(value.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		}
	}
};
</script>

<style></style>
